(() => {
  if (window.disturbBenefitsReady) return;
  window.disturbBenefitsReady = true;
  document.addEventListener('click', async event => {
    const link = event.target.closest?.('[data-aino-question]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const root = link.closest('[data-disturb-benefits]');
    if (root.dataset.locale !== 'fi') return;
    const helper = document.querySelector('aino-product-helper');
    const assistant = document.querySelector('disturb-assistant:not([hidden])');
    if (!helper && (!assistant || !assistant.input)) return;
    event.preventDefault();
    const status = root.querySelector('[data-benefits-status]');
    const setStatus = message => { status.textContent = message; status.hidden = !message; };
    if (root.dataset.waiting === 'true') return;
    if (helper) {
      root.dataset.waiting = 'true';
      try {
        if (!helper.product || typeof helper.ask !== 'function') {
          setStatus(root.dataset.waitMessage);
          await new Promise(resolve => {
            const done = () => {
              clearTimeout(timer);
              helper.removeEventListener('aino-product-ready', done);
              resolve();
            };
            const timer = setTimeout(done, 8000);
            helper.addEventListener('aino-product-ready', done, { once: true });
          });
        }
        if (!helper.product || typeof helper.ask !== 'function') { location.assign(link.href); return; }
        if (helper.busy) { helper.open(); setStatus(root.dataset.busyMessage); return; }
        setStatus('');
        await helper.ask(link.dataset.ainoQuestion);
      } finally { delete root.dataset.waiting; }
    } else {
      if (assistant.busy) { assistant.openChat(); setStatus(root.dataset.busyMessage); return; }
      setStatus('');
      await assistant.search(link.dataset.ainoQuestion);
    }
  });
})();
